var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-8 max-w-[300px] md:max-w-[400px] w-full",attrs:{"id":"tabs-content"}},[_c('v-message',{attrs:{"type":"error","message":_vm.errorMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }